<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-model="isView" v-if="targetImage != null">
        <v-card class="mt-3 pa-1">
            <Title title="画像のプレビュー">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card v-if="comments.length > 0" outlined class="mt-1">
                <v-card-text class="pa-1">
                    <v-container fluid v-if="!$vuetify.breakpoint.xs">
                        <v-row dense>
                            <v-col cols="12" xs="6" sm="4" md="3" lg="3" xl="3" v-for="comment in comments" :key="comment.dateTime" >
                                <v-card
                                    v-if="!$vuetify.breakpoint.xs"
                                    class="pa-1"
                                    :color="comment.isVisible ? 'primary' : ''"
                                    @click="comment.isVisible = !comment.isVisible" >
                                    <table :class="comment.isVisible ? 'primary white--text' : ''">
                                        <tr>
                                            <td rowspan="2">
                                                <v-avatar class="ma-0" size="30" rounded>
                                                    <v-img v-if="comment.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                    <v-img v-if="comment.userInfo.avaterURL != null" :src="comment.userInfo.avaterURL"/>
                                                </v-avatar>
                                            </td>
                                            <td style="width:100%">{{comment.userInfo.userName}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{comment.body.dateTime}}</td>
                                        </tr>
                                    </table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                    <template v-else>
                        <v-chip 
                            v-for="comment in comments" :key="comment.dateTime"
                            class="ma-1 pa-1"
                            label
                            small
                            :color="comment.isVisible ? 'primary' : ''"
                            @click="comment.isVisible = !comment.isVisible" >
                            {{comment.userInfo.userName}}
                        </v-chip>
                    </template>
                </v-card-text>
            </v-card>
            <v-card-text class="pa-1">
                <div style="position:relative">
                    <v-img
                        v-if="targetImage.state == 2 || targetImage.state == 4"
                        :src="targetImage.image" 
                        contain
                        class="ma-0">
                    </v-img>
                    <v-img
                        v-else-if="targetImage.state == 1 && targetImage.imageURL != null"                                        
                        :src="targetImage.imageURL" 
                        contain
                        class="ma-0">
                    </v-img>
                    <v-img
                        v-else-if="targetImage.state == 1 && targetImage.url != null"                                        
                        :src="targetImage.url" 
                        contain
                        class="ma-0">
                    </v-img>
                    <template v-for="comment in comments">
                        <v-img
                            v-if="comment.isVisible"
                            :key="comment.body.dateTime"
                            :src="comment.body.image"
                            style="position:absolute; top:0px; left:0px; width:100%"
                            contain />
                    </template>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton,
        },
        data: function () {
            return {
                isView: false,
                targetImage: null,
                comments: []
            }
        },
        methods: {
            show: function (image) {
                console.log("ImageViewer", "show", "image=", image)
                const self = this
                this.targetImage = image
                this.comments = []
                this.targetImage.comments.forEach(function(comment, index, array) {
                    const commentData = {
                        body: comment,
                        userInfo: {
                            userName: "",
                            avaterURL: ""
                        },
                        isVisible: true
                    }
                    console.log(commentData)
                    self.comments.push(commentData)
                    self.mi_userData(commentData.body.userUID, commentData.userInfo)
                })
                this.isView = true
            }
        }
    }
</script>
